// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconPaypal_cursor__3Mpsc","root":"IconPaypal_root__2e8Ht","svgPaypalIcon":"IconPaypal_svgPaypalIcon__3gKOH"};